var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5536 7.42175L14.8428 11.1326",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.542 35.2534V38.9643",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71045 22.2651H40.8191",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 35.2534V38.9643",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6995 9.27719L14.1409 6.71855C13.6043 6.17949 12.923 5.80747 12.1795 5.64749C11.4359 5.48751 10.6619 5.54643 9.95112 5.81712C9.24033 6.08781 8.62322 6.55867 8.17443 7.17274C7.72565 7.78681 7.46442 8.51777 7.42236 9.27719V31.5424C7.42236 32.5266 7.81333 33.4704 8.50925 34.1664C9.20517 34.8623 10.149 35.2532 11.1332 35.2532H33.3984C34.3826 35.2532 35.3265 34.8623 36.0224 34.1664C36.7183 33.4704 37.1093 32.5266 37.1093 31.5424V22.2652",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.3dc5ba37fdbf7c45a1d4462f7a572a21.svg";
export { ForwardRef as ReactComponent };